import { render, staticRenderFns } from "./maj.vue?vue&type=template&id=dc9dbcfc&scoped=true&"
import script from "./maj.vue?vue&type=script&lang=js&"
export * from "./maj.vue?vue&type=script&lang=js&"
import style0 from "./maj.vue?vue&type=style&index=0&id=dc9dbcfc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc9dbcfc",
  null
  
)

export default component.exports